<template>
 <v-dialog v-model="internalDialog" max-width="600">

    <v-card class="pa-6">
      <v-card-title class="text-h5 font-weight-bold d-flex align-center">
        <v-icon class="mr-3" color="primary">mdi-information-outline</v-icon>
        Image Upload Instructions
      </v-card-title>
      <v-card-text>
        <v-alert type="info" border="left" color="primary" class="mb-4">
          <strong>Supported Formats:</strong><br />
          <v-chip-group>
            <v-chip small>PNG</v-chip>
            <v-chip small>JPEG</v-chip>
            <v-chip small>WEBP</v-chip>
            <v-chip small>AVIF</v-chip>
          </v-chip-group>
          <div class="mt-2 text-caption">Max file size: 5MB</div>
        </v-alert>

        <v-alert type="warning" border="left" color="warning" class="mb-4">
          <strong>File Naming Convention:</strong><br />
          <v-list dense class="mt-2">
            <v-list-item>
              <v-list-item-icon>
                <v-icon small>mdi-account-school</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <strong>Students:</strong> Roll number (e.g., 123.jpg)
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon small>mdi-badge-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <strong>Employees:</strong> Contact number (e.g., 9876543210.jpg)
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('update:modelValue', false)">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { watch, ref } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits(['update:modelValue'])

const internalDialog = ref(props.modelValue)

watch(() => props.modelValue, (val) => {
  internalDialog.value = val
})

// Emit back to parent whenever local value changes
watch(internalDialog, (val) => {
  emit('update:modelValue', val)
})
</script>
